export default "__VITE_ASSET__be05fa2f__"